import React from "react";
import Layout from "../components/layout";
import Head from "../components/head";
//import  "./contact.css";
import Button from "../components/Button";
import { navigateTo } from "gatsby-link";
import styled from "styled-components"


function encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
  }

class Contact extends React.Component {
    constructor(props){
        super(props);
        this.state={}
    }
    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const form = e.target;
        fetch("/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: encode({
            "form-name": form.getAttribute("name"),
            ...this.state
          })
        })
          .then(() => navigateTo(form.getAttribute("action")))
          .catch(error => alert(error));
      };

    render(){
        return (
            <Layout >
                <Head title="Contact" />
                
                <ContactWrapper>
                    <h2>Contact me</h2>
                    <form   className="contact-form" 
                            name="contact"
                            method="POST"
                            action="/thanks"
                            data-netlify="true"
                            encType="application/x-www-form-urlencoded" 
                            data-netlify-honeypot="bot-field"
                            onSubmit={this.handleSubmit}>
                        <input className="hidden-input" type="hidden" name="form-name" value="contact" />
                        <div className="form-group">
                            <label className="form-label" >first Name</label>
                            <div className="input-wrapper">
                                <input type="text" name="firstname" onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Last Name</label>
                            <div className="input-wrapper">
                                <input type="text" name="lastname" onChange={this.handleChange}  />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <div className="input-wrapper">
                                <input type="email" name="email" onChange={this.handleChange} />
                            </div>
                        </div>
                        
                        <div className="form-group">
                            <label className="form-label">Company</label>
                            <div className="input-wrapper">
                                <input type="text" name="company" onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="form-group"> 
                            <label className="form-label">subject</label>
                            <div className="input-wrapper">
                                <input type="text" name="subject" onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Message</label>
                            <textarea rows={10} className="mess" name="message"  onChange={this.handleChange}/>
                        </div>
                        <Button label="send" type="submit"/>
                    </form>
                </ContactWrapper>
                
            </Layout>
        );
    }
}


const ContactWrapper = styled.div`
    padding: 5px;
    display: flex;
    max-width: 1300px;
    flex-direction: column;
    justify-content: space-evenly;
    //border: solid red;
    .contact-form{
        margin: 0;
        padding: 0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 40px;
        position: relative;
        @media screen and (max-width: 681px){
            grid-template-columns: 1fr  ;
        }
        .hidden-input{
            width: 0;
            height: 0;
        }
        .form-group{
            display: flex;
            //border: solid green;
            flex-direction: column;
            
           
            textarea{
                border-radius: 2px;
                border: 1px solid rgba(125, 132, 136,0.5);
                background: #27292c;
                color: whitesmoke;
                width: 100%;
                margin-left: auto;
                margin-right: auto;
                &:focus{
                    box-shadow: 0 0 10px rgba(0, 128, 0,0.3);
                }
                @media screen and (max-width: 681px){
                    width: 100%  ;
                }
            }
            .form-label{
                text-transform: lowercase;
                font-size: 0.8rem;
                font-weight: bolder;
            }
            .input-wrapper{
                input{
                    border-radius: 2px;
                    border: 1px solid rgba(125, 132, 136,0.5);
                    background: #27292c;
                    color: whitesmoke;
                    width: 100%;  
                    &:focus{
                        box-shadow: 0 0 10px rgba(0, 128, 0,0.3);
                    }
                    
                }
                
            }
        }
        
    }
`

export default Contact; 
